var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _polygon, _polygon2, _path8, _ellipse, _circle2, _path9, _circle3, _path10, _path11, _path12, _polygon3, _path13, _path14, _path15, _circle4, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInprogress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 906,
    height: 749.52408,
    viewBox: "0 0 906 749.52408",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in no time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M857.42078,783.2802a142.99439,142.99439,0,0,0,190.35559-212.45844Z",
    transform: "translate(-182 -64.23796)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M507.70923,287.04906,330.99207,481.85863a143.51972,143.51972,0,0,0,42.42871,53.42157L563.77637,322.82176A143.06762,143.06762,0,0,0,507.70923,287.04906Z",
    transform: "translate(-182 -64.23796)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M507,287.15147V173.238H414V286.79924a143.61506,143.61506,0,0,1,93,.35223Z",
    transform: "translate(-182 -64.23796)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M414,555.67668V672.238h93V555.32445a143.61506,143.61506,0,0,1-93,.35223Z",
    transform: "translate(-182 -64.23796)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M461,564.73828c-79.126,0-143.5-64.374-143.5-143.50049,0-79.126,64.374-143.5,143.5-143.5s143.5,64.374,143.5,143.5C604.5,500.36426,540.126,564.73828,461,564.73828Zm0-286.00049c-78.57471,0-142.5,63.9253-142.5,142.5S382.42529,563.73828,461,563.73828,603.5,499.8125,603.5,421.23779,539.57471,278.73779,461,278.73779Z",
    transform: "translate(-182 -64.23796)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M360,421.238a101,101,0,0,0,101,101v-202A101,101,0,0,0,360,421.238Z",
    transform: "translate(-182 -64.23796)",
    fill: "#575a89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M461,320.238v202a101,101,0,0,0,0-202Z",
    transform: "translate(-182 -64.23796)",
    fill: "#6c63ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 362,
    r: 14,
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "278.976 310.658 282.464 338.329 285.952 366 278.976 366 272 366 275.488 338.329 278.976 310.658",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "362.475 362.786 316.963 364.488 271.452 366.189 271.477 362.214 271.502 358.238 316.988 360.512 362.475 362.786",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M609.5,433.23779c-2.31543,0-3.25-1.59082-4.43359-3.60449-.2959-.50293-.61621-1.04834-.98731-1.625l.8418-.541c.3789.58886.70605,1.1455,1.00781,1.65917,1.17871,2.00635,1.82813,3.11133,3.57129,3.11133,5.79,0,10.5-9.645,10.5-21.5s-4.71-21.5-10.5-21.5c-3.34277,0-5.667,2.0625-7.53613,6.6875l-.92774-.375c2.04395-5.05713,4.6543-7.3125,8.46387-7.3125,6.34082,0,11.5,10.09326,11.5,22.5S615.84082,433.23779,609.5,433.23779Z",
    transform: "translate(-182 -64.23796)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 293,
    cy: 709,
    rx: 136,
    ry: 5,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 160,
    r: 21,
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M325,64.238A143.05294,143.05294,0,0,0,194.99207,266.85863L371.70923,72.04906A142.78437,142.78437,0,0,0,325,64.238Z",
    transform: "translate(-182 -64.23796)",
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.13643,
    cy: 234.45827,
    r: 31.2375,
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M747.58354,494.52136s24.94,63.0064,27.56531,63.0064,6.56316-23.6274,6.56316-23.6274l-15.7516-44.62953Z",
    transform: "translate(-182 -64.23796)",
    fill: "#ffb9b9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M784.33728,322.56638s6.56317,27.5653,3.9379,32.81584,5.25053,13.12633,5.25053,13.12633h18.37687l13.12634-21.00213,2.62526-9.18844s-7.8758-21.00213-6.56317-23.6274S784.33728,322.56638,784.33728,322.56638Z",
    transform: "translate(-182 -64.23796)",
    fill: "#ffb9b9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M784.33728,322.56638s6.56317,27.5653,3.9379,32.81584,5.25053,13.12633,5.25053,13.12633h18.37687l13.12634-21.00213,2.62526-9.18844s-7.8758-21.00213-6.56317-23.6274S784.33728,322.56638,784.33728,322.56638Z",
    transform: "translate(-182 -64.23796)",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "675.845 704.624 675.845 719.063 692.909 723.001 694.222 704.624 675.845 704.624",
    fill: "#575a89"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M788.27518,510.273s-18.37687,32.81584-11.8137,49.88007,31.5032,101.07277,31.5032,101.07277,14.439,47.25481,14.439,49.88007,11.8137,60.38114,15.7516,61.69378,39.379,5.25053,40.69164,1.31263,2.62526-24.94-1.31264-28.87794-24.94-126.01281-24.94-126.01281L849.969,578.5299l32.81584,101.07277s9.18843,60.38114,13.12633,64.319-7.8758,7.8758-3.9379,11.8137,18.37687,14.439,17.06423,18.37687,31.50321,3.9379,35.44111,1.31263,2.62526-43.3169,2.62526-43.3169L928.727,676.97741,907.72482,543.0888s-6.56317-39.379-11.8137-39.379S788.27518,510.273,788.27518,510.273Z",
    transform: "translate(-182 -64.23796)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M861.78265,778.05018s-10.50107-9.18843-15.7516-6.56317-22.31477,27.5653-27.5653,26.25267-13.12634,14.12633,0,15.439,34.12847-1.31264,34.12847-1.31264a101.3515,101.3515,0,0,0,13.12633,1.31264c5.25053,0,17.06424,1.31263,17.06424,0s-2.62527-31.19057-3.9379-31.19057S863.09528,781.98808,861.78265,778.05018Z",
    transform: "translate(-182 -64.23796)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M933.97749,768.86175s-13.12634-2.62527-14.439,0-6.56317,10.50106-6.56317,11.8137,2.62527,17.06423,2.62527,18.37686,2.62527,5.25054,5.25053,7.8758a4.63127,4.63127,0,0,1,1.31264,5.25054s34.12847,3.9379,34.12847-1.31264-3.9379-17.06423-6.56317-19.6895S941.85329,770.17438,933.97749,768.86175Z",
    transform: "translate(-182 -64.23796)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 618.08888,
    cy: 242.57682,
    r: 27.5653,
    fill: "#ffb9b9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M789.58781,356.69485s15.7516,9.18843,24.94-5.25053,38.06637,28.87793,38.06637,28.87793L860.47,514.21086s-14.439,1.31263-39.379,7.8758-36.75373-9.18843-36.75373-9.18843l-1.31263-76.13274,2.62526-35.4411-3.9379-28.87794,2.62527-17.06423Z",
    transform: "translate(-182 -64.23796)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M760.70988,373.75908s-10.50107,2.62527-13.12634,21.00214-7.8758,73.50747-7.8758,73.50747l6.56317,32.81584s18.37687-14.439,24.94-7.8758l-3.9379-19.68951,3.9379-11.8137-11.8137-51.1927Z",
    transform: "translate(-182 -64.23796)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M786.81693,334.38008s-2.47965,0-2.47965,9.18844-24.94,22.31476-24.94,22.31476-2.62526,3.9379-2.62526,14.439,0,35.4411,2.62526,43.3169,6.56317,34.12847,7.8758,36.75374,1.31264,14.439-1.31263,17.06424,6.56317,18.37686,9.18844,19.6895-9.18844,35.4411-2.62527,36.75373,18.37687-15.7516,22.31477-24.94,1.31263-136.51388,0-145.70231S786.81693,334.38008,786.81693,334.38008Z",
    transform: "translate(-182 -64.23796)",
    fill: "#575a89"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M823.38626,325.93268s-.98261-5.99157,5.58056-.741,7.8758,9.18843,7.8758,9.18843,34.12846,0,35.4411,3.9379-.78231,37.44959-.78231,37.44959l17.24931,64.13518s24.22463,74.30811,26.8499,76.93338-21.00213-11.8137-34.12847-1.31264-36.75373,15.75161-39.379,9.18844S810.59,365.88328,810.59,365.88328s0-24.94,3.9379-27.5653S823.38626,325.93268,823.38626,325.93268Z",
    transform: "translate(-182 -64.23796)",
    fill: "#575a89"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M893.28585,449.89182,888.03532,510.273l-1.31263,5.25053,19.6895,26.25267s3.9379-14.439,2.62526-19.6895,6.56317-64.319,6.56317-64.319Z",
    transform: "translate(-182 -64.23796)",
    fill: "#ffb9b9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M778.506,287.21988s-6.37761-16.58178,2.86993-22.00275l2.551,7.33425s23.27828-14.03075,29.337-10.84194l-5.73985,7.65313s27.10485,0,29.01813,10.52306l-9.56642.31888s10.20418,6.69649,10.52306,17.53843l-20.40835,1.27552,9.88529,5.73985s-36.99014,5.10209-45.91879-9.56641Z",
    transform: "translate(-182 -64.23796)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M772.98227,287.87539s7.35,14.7,17.15,11.025,0-17.15,0-17.15l-6.53333-3.26666Z",
    transform: "translate(-182 -64.23796)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 748.50032,
    width: 286,
    height: 1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M869.65845,340.94325s7.8758,1.31263,13.12634,10.50107,31.5032,69.56957,32.81583,72.19483,1.31263,38.06637,1.31263,38.06637-18.37686-10.50106-26.25266-3.9379L889.348,442.016l-17.06423-60.38113-2.62527-19.68951Z",
    transform: "translate(-182 -64.23796)",
    fill: "#6c63ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/inprogress.4336a80592c039620e4cc0a7aff6fe36.svg";
export { ForwardRef as ReactComponent };